import { calculateF, calculateR, calculateA, calculateM, calculateO  } from './utils/glyphsPaths';

export default [
  {
    type: 'glyph',
    id: 'F',
    path: calculateF,
    size: { width:200, height:200 },
    position: { x:40, y:40 },
    active: false
  },
  {
    type: 'glyph',
    id: 'R',
    path: calculateR,
    size: { width:200, height:200 },
    position: { x:240, y:40 },
    active: false
  },
  {
    type: 'glyph',
    id: 'A',
    path: calculateA,
    size: { width:200, height:200 },
    position: { x:440, y:40 },
    active: false
  },
  {
    type: 'glyph',
    id: 'M',
    path: calculateM,
    size: { width:200, height:200 },
    position: { x:40, y:240 },
    active: false
  },
  {
    type: 'glyph',
    id: 'O',
    path: calculateO,
    size: { width:200, height:200 },
    position: { x:240, y:240 },
    active: false
  }
]

